// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetMembershipDocumentsRequestModel from '../../model/get-membership-documents-request-model';
import GetMembershipDocumentsRequestDTO from '../dto/get-membership-documents-request-dto';
import dtoSchema from '../schemas/get-membership-documents-request-schema';

export default abstract class GetMembershipDocumentsRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetMembershipDocumentsRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.id = data.id;
      this.dateFrom = data.dateFrom;
      this.dateTo = data.dateTo;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  * @type {int64}
  */
  id?: number;
  /**
  * @type {date-time}
  */
  dateFrom?: string;
  /**
  * @type {date-time}
  */
  dateTo?: string;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetMembershipDocumentsRequestDTO>): GetMembershipDocumentsRequestModel;
  static toModel(dto: DeepPartial<GetMembershipDocumentsRequestDTO> | undefined | null): GetMembershipDocumentsRequestModel | undefined;
  static toModel(dto: DeepPartial<GetMembershipDocumentsRequestDTO> | undefined | null): GetMembershipDocumentsRequestModel | undefined {
    return dto ? new GetMembershipDocumentsRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetMembershipDocumentsRequestModel> | GetMembershipDocumentsRequestModel): GetMembershipDocumentsRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      id: unwrapped.id,
      dateFrom: unwrapped.dateFrom,
      dateTo: unwrapped.dateTo,
      searchCriteria: unwrapped.searchCriteria,
    } as GetMembershipDocumentsRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetMembershipDocumentsRequestModel, can not map to GetMembershipDocumentsRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
